import { create } from 'zustand'
import { DesignFirmType } from 'ts-interfaces'    


export const useImpersonateDesignFirm = create((set: any, get: any) => ({
    impersonate_firm: null as DesignFirmType | null,
    setImpersonateDesignFirm: (impersonate_firm: DesignFirmType) => set({ impersonate_firm: impersonate_firm }),
    clearImpersonateDesignFirm: () => set({ impersonate_firm: null }),
}))

